var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var roleAbstractEntities = ['PolicyContactRole', 'BAPolicyContactRole', 'BOPPolicyContactRole', 'CPPolicyContactRole', 'GLPolicyContactRole', 'PAPolicyContactRole', 'IMPolicyContactRole', 'PolicyNamedInsured', 'WCPolicyContactRole', 'WCLaborContact', 'PlcyNonPriNamedInsured', 'PolicyNamedInsured'];

var PolicyContactsSummaryTable = function () {
    function PolicyContactsSummaryTable(InsuranceSuiteMetadata, $filter, ContactService) {
        _classCallCheck(this, PolicyContactsSummaryTable);

        this._InsuranceSuiteMetadata = InsuranceSuiteMetadata;
        this._translateRole = function (name) {
            return $filter('translate')('gateway.contacts.common.views.policy.roles.' + name);
        };
        this._contactsService = ContactService;
    }

    _createClass(PolicyContactsSummaryTable, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.roleOptions = this._InsuranceSuiteMetadata.get('pc').types.getTypelist('PolicyContactRole').codes.filter(function (c) {
                return !roleAbstractEntities.includes(c.code);
            }) // Removes abstract entities for Policy Roles
            .map(function (c) {
                return { name: _this._translateRole(c.name), code: c.code };
            });

            this.selectedContactRole = null;
            this.resetQuery().then(function () {
                return _this.onInitialLoad({ totalContactCount: _this.totalContacts });
            });
        }
    }, {
        key: 'resetQuery',
        value: function resetQuery() {
            return this.loadContacts(0, this.pageSize);
        }
    }, {
        key: 'loadContacts',
        value: function loadContacts(toPage, pageSize) {
            var _this2 = this;

            var currentPage = toPage;
            var roleFilter = this.selectedContactRole ? [this.selectedContactRole] : [];
            this.loaded = false;

            return this._contactsService.getPolicyContactSummaries(this.policyNumber, roleFilter, currentPage, pageSize).then(function (data) {
                _this2.contacts = data.policyContacts;
                _this2.firstContact = currentPage * pageSize;
                _this2.currentPage = currentPage;
                _this2.totalContacts = data.maxNumberOfResults;
                _this2.loaded = true;
            });
        }
    }]);

    return PolicyContactsSummaryTable;
}();

PolicyContactsSummaryTable.$inject = ['InsuranceSuiteMetadata', '$filter', 'ContactService'];

export default PolicyContactsSummaryTable;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/contacts/common/components/PolicyContactsSummaryTable/PolicyContactsSummaryTable.js
// module id = 1624
// module chunks = 0